import { handleErrors } from "../utils/error-handler";
import apiClient from "./axios.config";

const vendorService = {
  getVendors: async () => {
    try {
      const response = await apiClient.get(`/website/vendor-listing`);
      return response?.data?.data || [];
    } catch (error) {
      throw handleErrors(error); // Throwing the processed error
    }
  },
  getVendorDetails: async (vendorId) => {
    try {
      const response = await apiClient.get(
        `/website/vendor/detail?vendorId=${vendorId}`,
        {
          vendorId,
        }
      );
      return response?.data?.data || [];
    } catch (error) {
      throw handleErrors(error);
    }
  },
};

export default vendorService;
